module.exports = __webpack_public_path__ + "static/media/options-fill.58cb779e.svg";